<div class="resource-card">
  <ng-content select="[luiResourceCardImage]"></ng-content>
  <div class="resource-card-content">
    <ng-content></ng-content>
  </div>
</div>
